/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignalsRouteImport } from './routes/signals'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RulesRouteImport } from './routes/rules'
import { Route as PerformanceRouteImport } from './routes/performance'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PositionsIndexRouteImport } from './routes/positions/index'
import { Route as PositionsTickerRouteImport } from './routes/positions/$ticker'

const SignalsRoute = SignalsRouteImport.update({
  id: '/signals',
  path: '/signals',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RulesRoute = RulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const PerformanceRoute = PerformanceRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PositionsIndexRoute = PositionsIndexRouteImport.update({
  id: '/positions/',
  path: '/positions/',
  getParentRoute: () => rootRouteImport,
} as any)
const PositionsTickerRoute = PositionsTickerRouteImport.update({
  id: '/positions/$ticker',
  path: '/positions/$ticker',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/history': typeof HistoryRoute
  '/performance': typeof PerformanceRoute
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRoute
  '/signals': typeof SignalsRoute
  '/positions/$ticker': typeof PositionsTickerRoute
  '/positions/': typeof PositionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/history': typeof HistoryRoute
  '/performance': typeof PerformanceRoute
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRoute
  '/signals': typeof SignalsRoute
  '/positions/$ticker': typeof PositionsTickerRoute
  '/positions': typeof PositionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/history': typeof HistoryRoute
  '/performance': typeof PerformanceRoute
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRoute
  '/signals': typeof SignalsRoute
  '/positions/$ticker': typeof PositionsTickerRoute
  '/positions/': typeof PositionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity'
    | '/history'
    | '/performance'
    | '/rules'
    | '/settings'
    | '/signals'
    | '/positions/$ticker'
    | '/positions/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity'
    | '/history'
    | '/performance'
    | '/rules'
    | '/settings'
    | '/signals'
    | '/positions/$ticker'
    | '/positions'
  id:
    | '__root__'
    | '/'
    | '/activity'
    | '/history'
    | '/performance'
    | '/rules'
    | '/settings'
    | '/signals'
    | '/positions/$ticker'
    | '/positions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivityRoute: typeof ActivityRoute
  HistoryRoute: typeof HistoryRoute
  PerformanceRoute: typeof PerformanceRoute
  RulesRoute: typeof RulesRoute
  SettingsRoute: typeof SettingsRoute
  SignalsRoute: typeof SignalsRoute
  PositionsTickerRoute: typeof PositionsTickerRoute
  PositionsIndexRoute: typeof PositionsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signals': {
      id: '/signals'
      path: '/signals'
      fullPath: '/signals'
      preLoaderRoute: typeof SignalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rules': {
      id: '/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof RulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/performance': {
      id: '/performance'
      path: '/performance'
      fullPath: '/performance'
      preLoaderRoute: typeof PerformanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/positions/': {
      id: '/positions/'
      path: '/positions'
      fullPath: '/positions/'
      preLoaderRoute: typeof PositionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/positions/$ticker': {
      id: '/positions/$ticker'
      path: '/positions/$ticker'
      fullPath: '/positions/$ticker'
      preLoaderRoute: typeof PositionsTickerRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivityRoute: ActivityRoute,
  HistoryRoute: HistoryRoute,
  PerformanceRoute: PerformanceRoute,
  RulesRoute: RulesRoute,
  SettingsRoute: SettingsRoute,
  SignalsRoute: SignalsRoute,
  PositionsTickerRoute: PositionsTickerRoute,
  PositionsIndexRoute: PositionsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
